export * from './close-icon'



// WEBPACK FOOTER //
// ./src/components/icons/index.js